import React from "react";

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

const IconTrash = ({ width = 16, height = 16, color = "#000" }: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M9.11133 1.82031C9.57165 1.82037 10.0133 2.00363 10.3389 2.3291C10.6643 2.65457 10.8475 3.0964 10.8477 3.55664V3.91797H13C13.4142 3.91797 13.75 4.25376 13.75 4.66797C13.75 5.08217 13.4142 5.41797 13 5.41797H12.5137V12.4453C12.5137 12.9055 12.3311 13.3473 12.0059 13.6729C11.6804 13.9983 11.2386 14.1815 10.7783 14.1816H5.22266C4.76226 14.1816 4.32069 13.9984 3.99512 13.6729C3.6696 13.3473 3.48633 12.9057 3.48633 12.4453V5.41797H3C2.58579 5.41797 2.25001 5.08217 2.25 4.66797C2.25 4.25376 2.58579 3.91797 3 3.91797H5.15332V3.55664C5.15343 3.0965 5.33585 2.65455 5.66113 2.3291C5.98658 2.00382 6.42853 1.82043 6.88867 1.82031H9.11133ZM4.73633 12.4453C4.73633 12.5742 4.78781 12.6979 4.87891 12.7891C4.97006 12.8802 5.09378 12.9316 5.22266 12.9316H10.7783C10.907 12.9315 11.031 12.8801 11.1221 12.7891C11.2129 12.6979 11.2637 12.574 11.2637 12.4453V5.41797H4.73633V12.4453ZM6.88867 6.82031C7.23371 6.82031 7.51344 7.10033 7.51367 7.44531V10.7783C7.51367 11.1235 7.23385 11.4033 6.88867 11.4033C6.54359 11.4032 6.26367 11.1234 6.26367 10.7783V7.44531C6.2639 7.1004 6.54374 6.82043 6.88867 6.82031ZM9.11133 6.82031C9.45626 6.82043 9.7361 7.1004 9.73633 7.44531V10.7783C9.73633 11.1234 9.45641 11.4032 9.11133 11.4033C8.76615 11.4033 8.48633 11.1235 8.48633 10.7783V7.44531C8.48656 7.10033 8.76629 6.82031 9.11133 6.82031ZM6.88867 3.07031C6.76006 3.07043 6.63595 3.12203 6.54492 3.21289C6.45406 3.30392 6.40343 3.42802 6.40332 3.55664V3.91797H9.59766V3.55664C9.59754 3.42792 9.54607 3.30394 9.45508 3.21289C9.36398 3.12184 9.24013 3.07037 9.11133 3.07031H6.88867Z"
        fill={color}
      />
    </svg>
  );
};

IconTrash.displayName = "Trash";
export default IconTrash;
